export function ReceiveEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="138"
        viewBox="0 0 200 138"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M158 102C152 96 144.667 93 136 93"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          d="M88 58V36M81 43L88 35L95 43"
          stroke="var(--clr-general-primary)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M112 35V57M105 50L112 58L119 50"
          stroke="var(--clr-general-primary)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M128 66H72C63.1634 66 56 74.1515 56 84.2069V113.793C56 123.848 63.1634 132 72 132H128C136.837 132 144 123.848 144 113.793V84.2069C144 74.1515 136.837 66 128 66Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M84 90C88 94.6667 92 94.6667 96 90"
          stroke="var(--clr-general-description)"
          stroke-linecap="round"
        />
        <path
          d="M104 90C108 94.6667 112 94.6667 116 90"
          stroke="var(--clr-general-description)"
          stroke-linecap="round"
        />
        <path
          d="M92 104C97.3333 108 102.667 108 108 104"
          stroke="var(--clr-general-description)"
          stroke-linecap="round"
        />
        <path
          opacity="0.18"
          d="M78.5 102.5C80.1569 102.5 81.5 101.157 81.5 99.5C81.5 97.8431 80.1569 96.5 78.5 96.5C76.8431 96.5 75.5 97.8431 75.5 99.5C75.5 101.157 76.8431 102.5 78.5 102.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M118.5 102.5C120.157 102.5 121.5 101.157 121.5 99.5C121.5 97.8431 120.157 96.5 118.5 96.5C116.843 96.5 115.5 97.8431 115.5 99.5C115.5 101.157 116.843 102.5 118.5 102.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.9"
          d="M164 104C170.095 107.854 170.708 114.149 165.633 117.503C161.366 112.835 161.159 107.454 164 104Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M164 104C168.668 99.7325 174.862 101.353 177.303 106.834C171.822 109.275 166.947 108.161 164 104Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M70 6L72 11L77 13L72 15L70 20L68 15L63 13L68 11L70 6Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M162 12.6C163.436 12.6 164.6 11.4359 164.6 10C164.6 8.56406 163.436 7.4 162 7.4C160.564 7.4 159.4 8.56406 159.4 10C159.4 11.4359 160.564 12.6 162 12.6Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
